import React from 'react';
import styles from './fspTileDetails.scss';
import { Component } from 'react';
import {ICurrencyInformation} from '../../../../components/articleTileGrid/article-tile/article-tile.d';
import { IPrice, IFlexibleSetPrice } from '../flex-set-tile.d';
import { FlexibleSetDiscountType } from '../flex-set-tile';
import classNames from 'classnames';
import { ArticleTileContext } from '../../../globalState/articleTileContext';
import { getWithVatValue } from '../../../../Common/html-helper';

export default class FspTileDetails extends Component<{
    description: string, currencyInformation: ICurrencyInformation, setPrice: IFlexibleSetPrice, isMobile: boolean,
    isGlobal: boolean}> {
    static contextType = ArticleTileContext;

    private originalPriceElementRef = React.createRef<HTMLDivElement>();
    private reducedPriceElementRef = React.createRef<HTMLDivElement>();
    private withVat: boolean;

    constructor(props) {
        super(props);

        this.withVat = getWithVatValue(this.props.currencyInformation.priceMode,
            typeof localStorage !== 'undefined' ? localStorage.getItem('PriceMode') : '');
    }

    private getPriceString(price?: IPrice): string {
        if (!price) {
            return '---';
        }

        let localizedPriceString: string;
        let priceString: string;

        // apc is not formatting decimal places, we have to do it:
        if (this.props.isGlobal) {
            priceString = price.net.toFixed(2);
        } else {
            priceString = this.withVat ? price.gross.toFixed(2) : price.net.toFixed(2);
        }

        const priceStringSplit = priceString.split('.');

        let intString = priceStringSplit[0];
        let seperatedIntString = '';
        const numberGroupSeparator =  this.props.currencyInformation.numberGroupSeparator;

        while (intString.length > 0) {
            if (intString.length > 3) {
                const last3Digits = intString.slice(-3);
                seperatedIntString =  numberGroupSeparator + last3Digits + seperatedIntString;
            } else {
                seperatedIntString = intString + seperatedIntString;
            }
            intString = intString.slice(0, -3);
        }

        const numberDecimalSeparator =  this.props.currencyInformation.numberDecimalSeparator;
        const fractionString = priceStringSplit[1];

        localizedPriceString = `${seperatedIntString}${numberDecimalSeparator}${fractionString}`;

        const currency = this.props.currencyInformation.symbol;
        const prependCurrencySymbol = this.props.currencyInformation.prependCurrencySymbol;

        if (prependCurrencySymbol)
            localizedPriceString = `${currency} ${localizedPriceString}`;
        else
            localizedPriceString = `${localizedPriceString} ${currency}`
        return localizedPriceString;
    }

    public render() {
        const showDiscountPrice = this.props.setPrice.discountType !== FlexibleSetDiscountType.FreeItem;
        const showBreakLineOriginalPrice = this.originalPriceElementRef.current ?
            this.originalPriceElementRef.current.clientHeight > 20 : false;
        const showBreakLineReducedPrice = this.reducedPriceElementRef.current ?
            this.reducedPriceElementRef.current.clientHeight > 20 : false;
       
        const l10n = this.context.l10n;
        const vatAcronym = this.withVat ? l10n.incVATAcronym : l10n.exVATAcronym;
        const vatString = !this.props.isGlobal ? `(${vatAcronym}) ` : '';
            
        return (
            <div className={classNames(styles.t_details)}>
                <div className={styles.d_title}>
                    {this.props.description}
                </div>
                <div className={styles.d_bottom}>
                    <div className={styles.d_price_container}>
                        {showDiscountPrice &&
                            <span className={styles.d_original_price} ref={this.originalPriceElementRef}>
                                {showBreakLineOriginalPrice && <br />}
                                <span className='notranslate'>{this.getPriceString(this.props.setPrice.originalPrice)}</span>
                            </span>
                        }
                        <span className={classNames(styles.d_price,
                            { [styles.d_reduced_price]: showDiscountPrice })} ref={this.reducedPriceElementRef}>
                                {showBreakLineReducedPrice && <br/>}
                            {!this.props.isGlobal ?
                                <span className='notranslate'>{this.getPriceString(this.props.setPrice.price)}</span>
                                : <span data-ge-price className='notranslate'>
                                    {this.getPriceString(this.props.setPrice.price)}
                                </span>
                            }
                        </span>
                    </div>
                    {vatString.length > 0 && <span className={styles.vat_string}>{vatString}</span>}
                </div>
            </div>
        );
    }
}
